import React, {FC} from 'react';
import {Box, Typography} from '@material-ui/core';

export interface ActivationsEmphasisProps {
    label: string;
    value: number | string;
    description: string;
}

const ActivationsEmphasis: FC<ActivationsEmphasisProps> = ({
    label,
    description,
    value
}: ActivationsEmphasisProps) => (
    <Box display="flex" flexDirection="column" justifyContent="center" width="inherit" px={4}>
        <Typography variant="caption" align="center" noWrap style={{fontSize: '13px'}}>
            {label}
        </Typography>
        <Typography
            variant="h4"
            align="center"
            style={{fontSize: '42px', fontWeight: 700, lineHeight: 1.7}}>
            {value}
        </Typography>
        <Typography variant="caption" align="center" style={{fontSize: '13px'}}>
            {description}
        </Typography>
    </Box>
);

export default ActivationsEmphasis;
